import { createAction, handleActions } from 'redux-actions'

import client from 'common/util/http'

import { selectBrokerOpId } from 'broker/selectors/auth'
import { valueOrNull } from 'broker/util/helper'

const LOAD_BROKER_COVERAGE_GEOJSON = 'LOAD_BROKER_COVERAGE_GEOJSON'
const FETCH_BROKER_COVERAGE_GEOJSON_BEGIN = 'FETCH_BROKER_COVERAGE_GEOJSON_BEGIN'
const FETCH_BROKER_COVERAGE_GEOJSON_END = 'FETCH_BROKER_COVERAGE_GEOJSON_END'

const loadBrokerCoverageGeojson = createAction(LOAD_BROKER_COVERAGE_GEOJSON)
const fetchBrokerCoverageGeoJsonBegin = createAction(FETCH_BROKER_COVERAGE_GEOJSON_BEGIN)
const fetchBrokerCoverageGeoJsonEnd = createAction(FETCH_BROKER_COVERAGE_GEOJSON_END)


export function fetchBrokerCoverageGeoJson() {
  return async (dispatch, getState) => {
    dispatch(fetchBrokerCoverageGeoJsonBegin())
    const broker_op_id = selectBrokerOpId(getState())
    try {
      const payload = await client.post('market_geometry', {
        data: { broker_op_id }
      })
      dispatch(loadBrokerCoverageGeojson(payload))
    } finally {
      dispatch(fetchBrokerCoverageGeoJsonEnd())
    }
  }
}

const cleanState = (payload = {}) => ({
  geo_json: valueOrNull(payload.geo_json),
  loading: false
})

export default handleActions({
  [LOAD_BROKER_COVERAGE_GEOJSON]: (state, { payload }) => ({
    ...state,
    geo_json: valueOrNull(payload.geo_json)
  }),
  [FETCH_BROKER_COVERAGE_GEOJSON_BEGIN]: state => ({
    ...state,
    loading: true
  }),
  [FETCH_BROKER_COVERAGE_GEOJSON_END]: state => ({
    ...state,
    loading: false
  })
}, cleanState())
